<template>
  <div class="userinfobox">
    <div class="w1000">
      <!-- 标题 -->
      <h2>{{userInfo.organization?'企业':'个人'}}信息展示</h2>

      <el-form v-model="infoForm" :rules="rules" label-position="right" :label-width="userInfo.organization?'180px':'100px'">

        <!-- 企业信息表单 -->
        <div class="organizationUserInfo" v-if="userInfo.organization">
          <el-form-item label="企业名称">
            <el-input v-model="infoForm.o_name" disabled></el-input>
          </el-form-item>
          <el-form-item label="所属行业">
            <el-select v-model="infoForm.o_domain" clearable placeholder="请选择企业所属行业">
              <el-option v-for="(x,i) in $fuwuData.suoshuhangye3g_" :key="i" :label="x" :value="x"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="企业性质">
            <el-select v-model="infoForm.o_type" clearable placeholder="请选择企业性质">
              <el-option v-for="(x,i) in $fuwuData.companyType" :key="i" :label="x" :value="x"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成立时间">
            <el-date-picker v-model="infoForm.o_publicTime" type="datetime" placeholder="选择日期时间"></el-date-picker>
          </el-form-item>
          <el-form-item label="注册资金">
            <el-input v-model="infoForm.o_registerCash"></el-input>
          </el-form-item>
          <el-form-item label="员工人数">
            <el-input v-model="infoForm.o_person"></el-input>
          </el-form-item>
          <el-form-item label="企业电话">
            <el-input v-model="infoForm.o_phone"></el-input>
          </el-form-item>
          <el-form-item label="企业传真">
            <el-input v-model="infoForm.o_fax"></el-input>
          </el-form-item>
          <el-form-item label="企业QQ">
            <el-input v-model="infoForm.o_QQ"></el-input>
          </el-form-item>
          <el-form-item label="企业微信">
            <el-input v-model="infoForm.o_weixin"></el-input>
          </el-form-item>
          <!-- <el-form-item label="区域选择">
            <el-select v-model="provinceId" clearable @change="remoteMethod($event,1)" placeholder="省" style="width:220px;">
              <el-option v-for="x in provinceArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
            </el-select>
            <el-select v-model="cityId" clearable @change="remoteMethod($event,2)" placeholder="市" style="width:220px;margin-left:10px;">
              <el-option v-for="x in cityArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
            </el-select>
            <el-select v-model="countyId" clearable @change="remoteMethod($event,3)" placeholder="县" style="width:220px;margin-left:10px;">
              <el-option v-for="x in countyArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="企业logo">
            <el-upload
              :class="{hide:isMax.logoisMax}"
              list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
              :action="$api.url_upload_pu" :file-list="imgfileList.logofileList" :limit="1" 
              :on-success="(response,file,fileList)=>imgAdd('logo',response,file,fileList)"
              :on-error="(err,file,fileList)=>imgError('logo',err,file,fileList)"
              :on-change="(file,fileList)=>imgChange('logo',file,fileList)"
              :on-remove="(file,fileList)=>imgHandleRemove('logo',file,fileList)">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="电子签名">
            <el-upload
              :class="{hide:isMax.signatureisMax}"
              list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
              :action="$api.url_upload_pu" :file-list="imgfileList.signaturefileList" :limit="1" 
              :on-success="(response,file,fileList)=>imgAdd('signature',response,file,fileList)"
              :on-error="(err,file,fileList)=>imgError('signature',err,file,fileList)"
              :on-change="(file,fileList)=>imgChange('signature',file,fileList)"
              :on-remove="(file,fileList)=>imgHandleRemove('signature',file,fileList)">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item label="营业执照">
            <el-upload
              :class="{hide:isMax.socialisMax}"
              list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
              :action="$api.url_upload_pu" :file-list="imgfileList.socialfileList" :limit="1" 
              :on-success="(response,file,fileList)=>imgAdd('social',response,file,fileList)"
              :on-error="(err,file,fileList)=>imgError('social',err,file,fileList)"
              :on-change="(file,fileList)=>imgChange('social',file,fileList)"
              :on-remove="(file,fileList)=>imgHandleRemove('social',file,fileList)">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="身份验证">
            <div class="idCardBox flex">
              <div class="front">
                <span>身份证正面照片</span>
                <el-form-item>
                  <el-upload
                    :class="{hide:isMax.frontisMax}"
                    ref="idCardFront" list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
                    :action="$api.url_upload_pu" :file-list="imgfileList.frontfileList" :limit="1" 
                    :on-success="(response,file,fileList)=>imgAdd('front',response,file,fileList)"
                    :on-error="(err,file,fileList)=>imgError('front',err,file,fileList)"
                    :on-change="(file,fileList)=>imgChange('front',file,fileList)"
                    :on-remove="(file,fileList)=>imgHandleRemove('front',file,fileList)">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </el-form-item>
              </div>
              <div class="back">
                <span>身份证反面照片</span>
                  <el-form-item>
                    <el-upload
                      :class="{hide:isMax.backisMax}"
                      list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
                      :action="$api.url_upload_pu" :file-list="imgfileList.backfileList" :limit="1" 
                      :on-success="(response,file,fileList)=>imgAdd('back',response,file,fileList)"
                      :on-error="(err,file,fileList)=>imgError('back',err,file,fileList)"
                      :on-change="(file,fileList)=>imgChange('back',file,fileList)"
                      :on-remove="(file,fileList)=>imgHandleRemove('back',file,fileList)">
                      <i class="el-icon-plus"></i>
                    </el-upload>
                  </el-form-item>
              </div>
            </div>
          </el-form-item> -->
          <el-form-item label="企业信用代码">
            <el-input v-model="infoForm.o_socialCode"></el-input>
          </el-form-item>
          <el-form-item label="企业地址">
            <el-input v-model="infoForm.o_address"></el-input>
          </el-form-item>
          <el-form-item label="企业简介">
            <el-input v-model="infoForm.o_description"></el-input>
          </el-form-item>
          <el-form-item label="视频简介">
            <el-upload
              class="avatar-uploader" :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
              accept=".mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv"
              :action="$api.url_upload_pu" :file-list="imgfileList.videofileList" :limit="1"
              :on-progress="(event,file,fileList)=>uploadVideoProcess('company',event,file,fileList)"
              :on-success="(res,file)=>handleVideoSuccess('company',res,file)"
              :before-upload="(file)=>beforeUploadVideo('company',file)"
              :on-remove="(file,fileList)=>removeVideo('company',file,fileList)">
              <video
                v-if="infoForm.o_videoUrl&&!videoFlag" controls="controls"
                :src="puUrl_x+'/'+infoForm.o_videoUrl" class="avatar video-avatar videoBox">您的浏览器不支持视频播放</video>
              <i v-if="!infoForm.o_videoUrl&&!videoFlag" class="el-icon-plus avatar-uploader-icon"></i>
              <el-progress v-if="videoFlag" type="circle" :percentage="videoUploadPercent" style="margin-top:7px;"></el-progress>
            </el-upload>
          </el-form-item>
        </div>

        <!-- 个人信息表单 -->
        <div class="personalUserInfo" v-if="userInfo.personal">
          <el-row class="basicInfo border-b">
            <el-form-item label="基本信息"></el-form-item>
            <el-col :span="12">
              <el-form-item label="姓名">
                <el-input v-model="infoForm.u_nickName"></el-input>
              </el-form-item>
              <el-form-item label="座右铭">
                <el-input v-model="infoForm.u_description"></el-input>
              </el-form-item>
              <el-form-item label="固定电话">
                <el-input v-model="infoForm.u_fixPhone"></el-input>
              </el-form-item>
              <el-form-item label="手机号码">
                <el-input v-model="infoForm.u_phone"></el-input>
              </el-form-item>
              <el-form-item label="邮箱">
                <el-input v-model="infoForm.u_email"></el-input>
              </el-form-item>
              <el-form-item label="QQ号码">
                <el-input v-model="infoForm.u_QQ"></el-input>
              </el-form-item>
              <el-form-item label="微信">
                <el-input v-model="infoForm.u_weixin"></el-input>
              </el-form-item>
              <el-form-item label="微博">
                <el-input v-model="infoForm.u_weibo"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="infoForm.u_sex" placeholder="请选择性别">
                  <el-option v-for="(x,i) in $fuwuData.sex" :key="i" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身高">
                <el-input v-model="infoForm.u_height" placeholder="以厘米为单位"></el-input>
              </el-form-item>
              <el-form-item label="出生日期">
                <el-date-picker v-model="infoForm.u_birthDayString" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
              </el-form-item>
              <el-form-item label="身份证">
                <el-input v-model="infoForm.u_idCard"></el-input>
              </el-form-item>
              <el-form-item label="所在地区">
                <el-input v-model="infoForm.u_liveAddress"></el-input>
              </el-form-item>
              
            </el-col>
            <el-col :span="12">
              <!-- <el-form-item label="区域选择">
                <el-select v-model="provinceId" clearable @change="remoteMethod($event,1)" placeholder="省" style="width:130px;">
                  <el-option v-for="x in provinceArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
                </el-select>
                <el-select v-model="cityId" clearable @change="remoteMethod($event,2)" placeholder="市" style="width:130px;">
                  <el-option v-for="x in cityArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
                </el-select>
                <el-select v-model="countyId" clearable @change="remoteMethod($event,3)" placeholder="县" style="width:130px;">
                  <el-option v-for="x in countyArr" :key="x.id" :label="x.name" :value="x.id"></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="个人logo">
                <el-upload
                  :class="{hide:isMax.userlogoisMax}"
                  list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
                  :action="$api.url_upload_pu" :file-list="imgfileList.userlogofileList" :limit="1" 
                  :on-success="(response,file,fileList)=>imgAdd('userlogo',response,file,fileList)"
                  :on-error="(err,file,fileList)=>imgError('userlogo',err,file,fileList)"
                  :on-change="(file,fileList)=>imgChange('userlogo',file,fileList)"
                  :on-remove="(file,fileList)=>imgHandleRemove('userlogo',file,fileList)">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="背景图">
                <el-upload
                  :class="{hide:isMax.userbgisMax}"
                  list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
                  :action="$api.url_upload_pu" :file-list="imgfileList.userbgfileList" :limit="1" 
                  :on-success="(response,file,fileList)=>imgAdd('userbg',response,file,fileList)"
                  :on-error="(err,file,fileList)=>imgError('userbg',err,file,fileList)"
                  :on-change="(file,fileList)=>imgChange('userbg',file,fileList)"
                  :on-remove="(file,fileList)=>imgHandleRemove('userbg',file,fileList)">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
              <el-form-item label="学历">
                <el-select v-model="infoForm.u_education" clearable>
                  <el-option v-for="x in $fuwuData.education_" :key="x" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="专业">
                <el-input v-model="infoForm.u_major"></el-input>
              </el-form-item>
              <el-form-item label="毕业院校">
                <el-input v-model="infoForm.u_school"></el-input>
              </el-form-item>
              <el-form-item label="普通话">
                <el-select v-model="infoForm.u_putonghua" placeholder="请选择">
                  <el-option v-for="(x,i) in $fuwuData.ability" :key="i" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="外语能力">
                <el-select v-model="infoForm.u_waiyu" placeholder="请选择">
                  <el-option v-for="(x,i) in $fuwuData.ability" :key="i" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="婚否">
                <el-select v-model="infoForm.u_marriage" placeholder="请选择">
                  <el-option v-for="(x,i) in $fuwuData.ismarriage" :key="i" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="jobwantedInfo border-b">
            <el-form-item label="求职信息"></el-form-item>
            <el-col :span="12">
              <el-form-item label="求职状态">
                <el-switch v-model="infoForm.u_startGetJob" active-text="求职" inactive-text="暂不求职"></el-switch>
              </el-form-item>
              <el-form-item label="期望薪资">
                <el-input v-model="infoForm.u_expectSalary" type="number"></el-input>
              </el-form-item>
              <el-form-item label="工作经验">
                <el-select v-model="infoForm.u_workYear" placeholder="请选择">
                  <el-option v-for="(x,i) in $fuwuData.workexperience" :key="i" :label="x"  :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="职业类别">
                <el-select v-model="infoForm.u_jobType" placeholder="请选择类别">
                  <el-option v-for="(x,i) in $fuwuData.zhiweileibie" :key="i" :label="x" :value="x"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="期望职位">
                <el-input v-model="infoForm.u_expectJob"></el-input>
              </el-form-item>
              <el-form-item label="视频简介">
                <el-upload
                  class="avatar-uploader" :data="{FoldPath:'上传目录',SecretKey:'安全验证'}"
                  accept=".mp4,.mkv,.rm,.rmvb,.mpeg1-4,.mov,.mtv,.dat,.wmv,.avi,.3gp,.amv,.dmv,.flv"
                  :action="$api.url_upload_pu" :file-list="imgfileList.uservideofileList" :limit="1"
                  :on-progress="(event,file,fileList)=>uploadVideoProcess('personal',event,file,fileList)"
                  :on-success="(res,file)=>handleVideoSuccess('personal',res,file)"
                  :before-upload="(file)=>beforeUploadVideo('personal',file)"
                  :on-remove="(file,fileList)=>removeVideo('personal',file,fileList)">
                  <video
                    v-if="infoForm.u_videoUrl&&!videoFlag" controls="controls"
                    :src="puUrl_x+'/'+infoForm.u_videoUrl" class="avatar video-avatar videoBox">您的浏览器不支持视频播放</video>
                  <i v-if="infoForm.u_videoUrl =='' && !videoFlag" class="el-icon-plus avatar-uploader-icon"></i>
                  <el-progress v-if="videoFlag" type="circle" :percentage="isMax.userisShowUploadVideo" style="margin-top:7px;"></el-progress>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="教育经历">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.u_educationExperience" maxlength="2000" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="工作经历">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.u_workExperience" maxlength="2000" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="自我评价">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.selfComments" maxlength="200" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="个人简历">
                <el-upload
                  class="upload-demo" accept=".doc,.docx,.pdf"
                  :action="$api.url_upload_pr" :file-list="imgfileList.resumefileList" :limit='1'
                  :on-preview="clickFileLise"
                  :before-upload="beforeUploadResume"
                  :on-success="handleChangeResumeFile"
                  :on-remove="removeResumeFile">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传word/pdf文件，且不超过10mb</div>
                </el-upload>
              </el-form-item>
              <!-- <el-form-item label="职业规划">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.u_career" maxlength="200" show-word-limit></el-input>
              </el-form-item> -->
              <!-- <el-form-item label="联系名片">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.selfInfo" maxlength="200" show-word-limit></el-input>
              </el-form-item> -->
            </el-col>
          </el-row>
          <el-row class="friendsInfo border-b" style="margin-bottom: 20px">
            <el-form-item label="交友信息"></el-form-item>
            <el-col :span="12">
              <el-form-item label="是否公开">
                <el-switch v-model="infoForm.openFriends" active-text="公开" inactive-text="暂不"></el-switch>
              </el-form-item>
              <el-form-item label="年龄">
                <el-input v-model="infoForm.f_age" placeholder="岁"></el-input>
              </el-form-item>
              <el-form-item label="体重">
                <el-input v-model="infoForm.f_weight" placeholder="公斤"></el-input>
              </el-form-item>
              <el-form-item label="性格">
                <el-input v-model="infoForm.f_disposition" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="交友方式">
                <el-input v-model="infoForm.f_friends" placeholder=""></el-input>
              </el-form-item>
              <el-form-item label="工作地点">
                <el-input v-model="infoForm.f_wordAddress" placeholder=""></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="交友要求">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.f_requirement" maxlength="2000" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="秘密档案">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.f_secDoc" maxlength="2000" show-word-limit></el-input>
              </el-form-item>
              <el-form-item label="自我介绍">
                <el-input :rows="4" type="textarea" style="width:360px;" placeholder="请输入内容" v-model="infoForm.f_description" maxlength="2000" show-word-limit></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="lawyerInfo" v-if="!infoForm.layer">
            <el-form-item label="律师申请" label-width="120px">
              <el-button type="text" @click="isShowLawyerApplyDialog=true">点击进行律师申请</el-button>
            </el-form-item>
          </el-row>
          <el-row class="lawyerInfo">
            <el-form-item label="企业申请" label-width="120px">
              <el-button type="text" @click="isShowCompanyApplyDialog=true">点击进行企业申请</el-button>
            </el-form-item>
          </el-row>
          <el-row class="lawyerInfo" v-if="!infoForm.o_vipType">
            <el-form-item label="VIP申请" label-width="120px">
              <el-button type="text" @click="isShowVipApplyDialog=true">点击进行VIP申请</el-button>
            </el-form-item>
          </el-row>
        </div>

      </el-form>

      <div style="margin-top: 20px">
        <el-button style="margin: 0px auto;display: block;" type="primary" @click="submit()">确认修改</el-button>
      </div>
    </div>
    
    <el-dialog title="律师申请" :visible.sync="isShowLawyerApplyDialog" :close-on-click-modal="false" width="55%">
      <el-form :model="lawyerapplyform" label-width="150px">
        <el-form-item label="相关材料图片上传：">
          <el-upload
            :class="{hide:isMax.lawyerisMax}"
            list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
            :action="$api.url_upload_pu" :file-list="imgfileList.lawyerfileList" :limit="5"
            :on-success="(response,file,fileList)=>imgAdd('lawyer',response,file,fileList)"
            :on-error="(err,file,fileList)=>imgError('lawyer',err,file,fileList)"
            :on-change="(file,fileList)=>imgChange('lawyer',file,fileList)"
            :on-remove="(file,fileList)=>imgHandleRemove('lawyer',file,fileList)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="申请状态：">
          <el-select v-model="lawyerapplyform.status" disabled placeholder="当前申请状态">
            <el-option v-for="(x,i) in $fuwuData.layerApplyStatus" :key="i" :label="x.label" :value="x.val"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowLawyerApplyDialog=false">取 消</el-button>
        <el-button type="primary" @click="submitLayerApply">提交律师申请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="企业申请" :visible.sync="isShowCompanyApplyDialog" :close-on-click-modal="false" width="55%">
      <el-form ref="companyapplyform" :model="companyapplyform" label-width="150px">
        <el-form-item label="营业执照上传：">
          <el-upload
            :class="{hide:isMax.companyisMax}"
            list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.gif"
            :action="$api.url_upload_pu" :file-list="imgfileList.companyfileList" :limit="1"
            :on-success="(response,file,fileList)=>imgAdd('company',response,file,fileList)"
            :on-error="(err,file,fileList)=>imgError('company',err,file,fileList)"
            :on-change="(file,fileList)=>imgChange('company',file,fileList)"
            :on-remove="(file,fileList)=>imgHandleRemove('company',file,fileList)">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="企业名称：">
          <el-input v-model="companyapplyform.o_name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="申请状态：">
          <el-select v-model="companyapplyform.status" disabled placeholder="当前申请状态">
            <el-option v-for="(x,i) in $fuwuData.companyApplyStatus" :key="i" :label="x.label" :value="x.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCompanyApplyDialog=false">取 消</el-button>
        <el-button type="primary" @click="submitCompanyApply">提交企业申请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="VIP申请" :visible.sync="isShowVipApplyDialog" :close-on-click-modal="false" width="55%">
      <el-form ref="vipapplyform" :model="vipapplyform" label-width="150px">
        <el-form-item label="申请描述：">
          <el-input clearable type="textarea" v-model="vipapplyform.applyDescription" :rows="4"></el-input>
        </el-form-item>
        <!-- <el-form-item label="申请状态：">
          <el-select v-model="vipapplyform.status" disabled placeholder="当前申请状态">
            <el-option v-for="(x,i) in $fuwuData.companyApplyStatus" :key="i" :label="x.label" :value="x.value"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowVipApplyDialog=false">取 消</el-button>
        <el-button type="primary" @click="submitVipApply">提交企业申请</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import axios from 'axios'
import mixins from '@/Mixins/mixin_3g48'
import mixins_headimg from '@/Mixins/mixin_3g48HeadImg'
export default {
  mixins: [mixins,mixins_headimg],
  data() {
    return {
      rules: {},
      pickerOptions: {//时间选择器参数
        disabledDate(time) {
          return time.getTime() > Date.now()
        }
      },
      provinceId: '',
      provinceArr: [],
      cityId: '',
      cityArr: [],
      countyId: '',
      countyArr: [],
      videoFlag: false,//上传视频，是否显示进度条
      videoUploadPercent: '',//上传视频，进度条的进度

      imgfileList: {
        logofileList: [],//logo图片   文件数组
        socialfileList: [],//营业执照图片  文件数组
        signaturefileList: [],
        frontfileList: [],//身份证正面图片   文件数组
        backfileList: [],//身份证反面图片   文件数组
        videofileList: [],//视频   文件数组

        resumefileList: [],//个人简历  文件数组
        userlogofileList: [],//个人logo图片   文件数组
        userbgfileList: [],//个人背景图片   文件数组
        uservideofileList: [],//个人视频简介  文件数组
        lawyerfileList: [],//律师申请  文件数组
        companyfileList: [],//律师申请  文件数组
      },
      isMax: {//是否显示添加符号
        logoisMax: false,//企业LOGO上传之后变为ture，隐藏添加符号
        socialisMax: false,//企业营业执照图片上传之后变为ture，隐藏添加符号
        signatureisMax: false,
        frontisMax: false,//企业身份证正面照上传之后变为ture，隐藏添加符号
        backisMax: false,//企业身份证正面照上传之后变为ture，隐藏添加符号
        isShowUploadVideo: false,//是否显示已上传文件列表

        userlogoisMax: false,//个人logo上传之后变为ture，隐藏添加符号
        userbgisMax: false,//个人背景图上传之后变为ture，隐藏添加符号
        userisShowUploadVideo: false,//是否显示已上传文件列表
        lawyerisMax: false,//律师申请上传图片，是否显示+
        companyisMax: false,//律师申请上传图片，是否显示+
      },
      infoForm: {//表单对象信息
        o_homeUrl: '',//企业logo图片的URL
        o_idCardFront: '',//身份证正面照片
        o_idCardBack: '',//身份证反面照片
        o_socialCodeUrl: '',//营业执照照片
        o_signatureUrl: '',
        o_videoUrl: '',//视频文件
        o_confirm: false,//默认没有通过身份验证

        u_logo: '',//个人logo
        u_backgroundImg: '',//个人背景图
      },
      dialogVisible: false,//预览图片默认不显示

      isShowLawyerApplyDialog: false,//控制律师申请的弹框显隐
      lawyerapplyform: {//律师申请的表单信息
        imgId: [],//材料图片数组
        status: '',
      },
      isShowCompanyApplyDialog: false,//控制律师申请的弹框显隐
      companyapplyform: {//律师申请的表单信息
        imgId: [],//材料图片数组
        o_img: '',
        status: '',
      },
      isShowVipApplyDialog: false,//控制VIP申请的弹框显隐
      vipapplyform: {//VIP申请的表单信息
        applyDescription: '',
        status: '',
      },
    }
  },
  watch: {
    provinceId(val) {
      if (val == '') {
        this.areaGet({ value: { areaId: 0 }, key: 0 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 1 })
      }
    },
    cityId(val) {
      let areaId = this.provinceId
      if (val == '') {
        this.areaGet({ value: { areaId: areaId }, key: 1 })
      } else {
        this.areaGet({ value: { areaId: val }, key: 2 })
      }
    },
    isShowLawyerApplyDialog(val) {
      if (val) {
        let userId = this.userInfo.id
        this.$api.util_search('lvshisq', { userId }).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            console.log(_R)
            if (_R.length > 0) {
              this.lawyerapplyform = _R[0]
              this.lawyerapplyform.imgId.forEach(x => {
                let imgs = []
                imgs.push({ url: this.publicFileUrl + '/' + x })
                // console.log(`%c123:`, 'color: #f00;', this.imgfileList.lawyerfileList, imgs)
                // if (JSON.stringify(this.imgfileList.lawyerfileList) !== JSON.stringify(imgs)) {
                  this.imgfileList.lawyerfileList = imgs
                // }
                this.isMax.lawyerisMax = this.imgfileList.lawyerfileList.length >= 5 ? true : false
              })
            }
          } else { this._status(res.data) }
        })
      }
    },
    isShowCompanyApplyDialog(val) {
      if (val) {
        let userId = this.userInfo.id
        this.$api.util_search('qiyesq', { userId }).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            console.log(_R)
            if (_R.length > 0) {
              this.companyapplyform = _R[0]
              if (this.companyapplyform.o_img) {
                let imgs = []
                imgs.push({ url: this.publicFileUrl + '/' + this.companyapplyform.o_img })
                this.imgfileList.companyfileList = imgs
                this.isMax.companyisMax = this.imgfileList.companyfileList.length >= 1
              }
            }
          } else { this._status(res.data) }
        })
      }
    },
    isShowVipApplyDialog(val) {
      if (val) {
        let userId = this.userInfo.id
        this.$api.util_search('vipsq', { userId }).then(res => {
          if (res.data.status == 0) {
            let _R = JSON.parse(res.data.data)
            console.log(_R)
            if (_R.length > 0) {
              this.vipapplyform = _R[0]
            }
          } else { this._status(res.data) }
        })
      }
    }
  },
  methods: {
    async setAreaId() {
      if (this.userInfo.countyId == '') {
        if (this.userInfo.cityId == '') {
          if (this.userInfo.provinceId == '') {
            this.areaGet({ value: { areaId: 0 }, key: 0 })
          } else {
            await this.areaGet({ value: { areaId: 0 }, key: 0 })
            this.provinceId = this.userInfo.provinceId
            this.areaGet({ value: { areaId: this.provinceId }, key: 1 })
          }
        } else {
          await this.areaGet({ value: { areaId: 0 }, key: 0 })
          this.provinceId = this.userInfo.provinceId
          await this.areaGet({ value: { areaId: this.provinceId }, key: 1 })
          this.cityId = this.userInfo.cityId
          this.areaGet({ value: { areaId: this.cityId }, key: 2 })
        }
      } else {
        await this.areaGet({ value: { areaId: 0 }, key: 0 })
        this.provinceId = this.userInfo.provinceId
        await this.areaGet({ value: { areaId: this.provinceId }, key: 1 })
        this.cityId = this.userInfo.cityId
        await this.areaGet({ value: { areaId: this.cityId }, key: 2 })
        this.countyId = this.userInfo.countyId
      }
    },
    // 获取位置
    areaGet(data) {
      return this.$api.getPlace(data.value).then(res => {
        if (res.data.status === 0 ) {
          let response = JSON.parse(res.data.data)
          switch(data.key) {
            case 0 : this.provinceArr = response;this.cityArr = [];this.countyArr = []; break
            case 1 : this.cityArr = response;this.countyArr = []; break
            case 2 : this.countyArr = response; break
          }
        } else{ this._status(res.data) }
      })
    },
    // 清空下级
    remoteMethod(value, num) {
      switch(num) {
        case 1: this.cityId = this.countyId = ''; break
        case 2: this.countyId= ''; break
        case 3: break
      }
    },
    //发送请求，获取账户的信息
    getDatainfo() {
      let id = this.userInfo.id
      this.$api._user_userInfo(id).then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          localStorage.setItem('loginData', JSON.stringify(_R))
          this.infoForm = JSON.parse(JSON.stringify(_R))
          this.showImg()
          console.log(this.infoForm)
        } else { this._status(res.data) }
      })
    },
    //图片,视频回显
    async showImg() {
      await this.$api.getPublicFileUrl().then(res => {
        this.publicFileUrl = res.data.data
      })
      if (this.userInfo.organization) {//登录账号为企业账号
        if (this.infoForm.o_homeUrl) {//logo图片回显
          this.imgfileList.logofileList=[{ url: this.publicFileUrl + '/' + this.infoForm.o_homeUrl }]
          this.isMax.logoisMax = true
        }
        if (this.infoForm.o_socialCodeUrl) {//印业执照图片回显
          this.imgfileList.socialfileList=[{ url: this.publicFileUrl + '/' + this.infoForm.o_socialCodeUrl }]
          this.isMax.socialisMax = true
        }
        if (this.infoForm.o_signatureUrl) {//印业执照图片回显
          this.imgfileList.signaturefileList=[{ url: this.publicFileUrl + '/' + this.infoForm.o_signatureUrl }]
          this.isMax.signatureisMax = true
        }
        if (this.infoForm.o_idCardFront) {//身份证正面照图片回显
          this.imgfileList.frontfileList=[{ url: this.publicFileUrl + '/' + this.infoForm.o_idCardFront }]
          this.isMax.frontisMax = true
        }
        if (this.infoForm.o_idCardBack) {//身份证反面照图片回显
          this.imgfileList.backfileList=[{ url: this.publicFileUrl + '/' + this.infoForm.o_idCardBack }]
          this.isMax.backisMax = true
        }
        if (this.infoForm.o_videoUrl) {//视频  回显
          this.imgfileList.videofileList=[{ url: this.puUrl_x+'/'+this.infoForm.o_videoUrl,name: '视频简介' }]
        }
      }
      if (this.userInfo.personal) {//登录账号为个人账号
        if (this.infoForm.u_logo) {//个人logo图片回显
          this.imgfileList.userlogofileList = [{ url: this.publicFileUrl + '/' + this.infoForm.u_logo }]
          this.isMax.userlogoisMax = true
        }
        if (this.infoForm.u_backgroundImg) {//个人背景图片回显
          this.imgfileList.userbgfileList = [{ url: this.publicFileUrl + '/' + this.infoForm.u_backgroundImg }]
          this.isMax.userbgisMax = true
        }
        if (this.infoForm.u_resumeNameAndIds) {//个人简介
          this.imgfileList.resumefileList = [{ url: this.infoForm.u_resumeNameAndIds.fileUrl,name:this.infoForm.u_resumeNameAndIds.fileName }]
        }
        if (this.infoForm.u_videoUrl) {//视频  回显
          this.imgfileList.uservideofileList = [{ url: this.puUrl_x+'/'+this.infoForm.o_videoUrl,name: '视频简介' }]
        }
      }
    },

    //图片上传成功
    imgAdd(str, response, file, fileList) {
      let strList = str + 'fileList'
      let strisMax = str + 'isMax'
      let strArr = ['logo','social','front','back','userlogo','userbg','signature']
      let urlArr = ['o_homeUrl','o_socialCodeUrl','o_idCardFront','o_idCardBack','u_logo','u_backgroundImg','o_signatureUrl']
      this.imgfileList[strList] = fileList
      this.$message.success('上传成功！')
      if (str === 'lawyer') {
        this.lawyerapplyform.imgId.push(JSON.parse(response.data).fileId)
      } else if (str === 'company') {
        this.companyapplyform.o_img = JSON.parse(response.data).fileId
        console.log(this.imgfileList.companyfileList)
      } else {
        let strUrl = urlArr[strArr.indexOf(str)]
        this.infoForm[strUrl] = JSON.parse(response.data).fileId
      }
      if (str === 'front' || str === 'back') {//判断是添加身份证图片，当正反面都上传时，身份验证为true，否则为false
        if (this.infoForm.o_idCardFront && this.infoForm.o_idCardBack) {//当身份证正反面都上传了图片时，确认用户已经通过身份验证
          this.infoForm.o_confirm = true
        } else {
          this.infoForm.o_confirm = false
        }
      }
    },
    //图片上传失败
    imgError(str,err, file, fileList) {
      let strisMax = str + 'isMax'
			this.$message.error('上传失败')
      // str === 'lawyer' ? this.isMax.lawyerisMax = fileList.length >= 5 : this.isMax[strisMax] = fileList.length >= 1
      if (str === 'lawyer') {
        this.isMax[strisMax] = fileList.length >= 5
      } else {
        this.isMax[strisMax] = fileList.length >= 1
      }
    },
    //图片状态改变时触发
		imgChange(str,file,fileList) {
      let strisMax = str + 'isMax'
      str === 'lawyer' ? this.isMax[strisMax] = fileList.length >= 5 : this.isMax[strisMax] = fileList.length >= 1
      if (str === 'lawyer') {
        this.isMax[strisMax] = fileList.length >= 5
      } else {
        this.isMax[strisMax] = fileList.length >= 1
      }
    },
    //图片移除
    imgHandleRemove(str, file, fileList) {
      let strList = str + 'fileList'
      let strisMax = str + 'isMax'
      this.imgfileList[strList] = fileList
      let strArr = ['logo','social','front','back','userlogo','userbg','signature']
      let urlArr = ['o_homeUrl','o_socialCodeUrl','o_idCardFront','o_idCardBack','u_logo','u_backgroundImg','o_signatureUrl']
      if (str === 'lawyer') {
        let deleteindex =  this.lawyerapplyform.imgId.indexOf(JSON.parse(file.response.data).fileId)
        this.lawyerapplyform.imgId.splice(deleteindex, 1)
        // console.log(this.lawyerapplyform.imgId)
      } else if (str === 'company') {
        let deleteindex =  this.companyapplyform.imgId.indexOf(JSON.parse(file.response.data).fileId)
        this.companyapplyform.imgId.splice(deleteindex, 1)
        // console.log(this.companyapplyform.imgId)
      } else {
        let strUrl = urlArr[strArr.indexOf(str)]
        this.infoForm[strUrl] = ''
      }
      if (fileList.length < 1) { this.isMax[strisMax] = false }
      if (str == 'front' || str == ('back')) {//当移除的图片是身份证正反面时，身份验证自动变为false
        this.infoForm.o_confirm = false
      }
    },
    
    //视频上传前回调
    beforeUploadVideo(str,file) {
      let fileSize = file.size / 1024 / 1024 < 500 //限制文件大小
      if (['video/mp4'].includes(file.type)) {//限制格式为mp4
        if (!fileSize) {//限制文件大小不超过500M
          this.$message.warning('视频大小不能超过500MB')
          return false
        } else { this.$message.success('上传成功！') }
      } else {
        this.$message.warning('目前仅支持mp4文件格式上传！')
        return false
      }
      str == 'company' ? this.isMax.isShowUploadVideo = false : this.isMax.userisShowUploadVideo = false
    },
    //视频上传进度条
    uploadVideoProcess(str,event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage.toFixed(0) * 1
    },
    //视频上传成功回调
    handleVideoSuccess(str,res, file) {
      str == 'company' ? this.isMax.isShowUploadVideo = true : this.isMax.userisShowUploadVideo = true
      this.videoFlag = false
      this.videoUploadPercent = 0
      // 前台上传地址
      if (file.status == 'success') {
        let videoId = JSON.parse(res.data).fileId
        // axios.get('http://39.98.198.162:8888/public/bucketEndpoint').then(res => {
          // let _R = res.data.data
          // let url = _R + '/' + videoId
          // str == 'company' ? this.infoForm.o_videoUrl = url : this.infoForm.u_videoUrl = url
        // }).catch(() => { console.log('获取数据失败') })
        str == 'company' ? this.infoForm.o_videoUrl = videoId : this.infoForm.u_videoUrl = videoId
      } else { this.$message.warning('上传失败，请重新上传') }
    },
    //移除视频
    removeVideo(str,file, fileList) {
      if (str == 'company') {
        this.imgfileList.videofileList = fileList
        this.infoForm.o_videoUrl = ''
      } else {
        this.imgfileList.uservideofileList = fileList
        this.infoForm.u_videoUrl = ''
      }
    },


    //简历上传之前回调
    beforeUploadResume(file) {
      let fileSize = file.size / 1024 / 1024 < 10 //限制文件大小
      let resumeType = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/pdf']
      if (resumeType.indexOf(file.type) != -1) {
        if (!fileSize) {
          this.$message.warning('简历文件大小不能超过10MB')
          return false
        } else { this.$message.success('上传成功！') }
      } else {
        this.$message.warning('格式不正确,只支持word文档或者PDF文档')
        return false
      }
    },
    //简历文件上传成功回调
    handleChangeResumeFile(res, file) {
      // this.infoForm.fileName = file.name
      // this.infoForm.fileId = file.response.data
      let _R = JSON.parse(res.data)
      console.log(_R)
      this.infoForm.u_resumeNameAndIds = {
        fileName: _R.fileName,
        fileId: _R.fileId,
      }
      console.log(this.infoForm.u_resumeNameAndIds)
    },
    removeResumeFile(file, fileList) {
      this.infoForm.u_resumeNameAndIds = ''
    },
    //有文件时，点击文件列表中的文件
    clickFileLise(file) {
      // window.open(this.publicFileUrl + '/' + this.infoForm.u_resumeNameAndIds)
      // <a :href='`https://view.officeapps.live.com/op/view.aspx?src=${url}${scope.row.fileId}`'
      //         target='_blank' rel='noopener noreferrer'>附件</a>
    },
    //提交个人信息
    submit() {
      let rD = {}
      console.log(this.provinceId,this.cityId,this.countyId)
      !this.countyId
        ? (!this.cityId
          ? (!this.provinceId
            ? this.infoForm.areaId == ''
            : this.infoForm.areaId = this.provinceId)
          : this.infoForm.areaId = this.cityId)
        : this.infoForm.areaId = this.countyId
      if (this.userInfo.organization) {//登录账号为企业账号
        this.infoForm.o_publicTime = new Date(this.infoForm.o_publicTime).getTime()
        rD.id = this.userInfo.id
        let mapList = [//以下属性是，发生改变的时候才传
          'areaId',
          'o_name', 
          'o_domain',
          'o_type',
          'o_publicTime',
          'o_registerCash',
          'o_person',
          'o_homeUrl',
          'o_socialCode',
          'o_address',
          'o_description',
          'o_videoUrl',
          'o_socialCodeUrl',
          'o_signatureUrl',
          'o_idCardFront',
          'o_idCardBack',
          'o_confirm',
          'o_phone',
          'o_fax',
          'o_QQ',
          'o_weixin',
        ]
        mapList.forEach(x => {//将修改过的属性和值赋给rD
          this.infoForm[x] != this.userInfo[x] ? rD[x] = this.infoForm[x] : ''
        })
        if (Object.keys(rD).length == 1) {//未改变任何数据
          this.$message.warning('您未改变任何数据!')
        } else {
          console.log(rD)
          if (this.provinceId == '') {
            this.$message.warning('请选择地区!')
          } else {
            this.$api._user_modify(rD).then(res =>{
              if (res.data.status === 0) {
                this.$message.success('修改成功!')
                let id = rD.id
                this.$api._user_userInfo(id).then(res1 => {
                  let data = JSON.parse(res1.data.data)
                  console.log(data)
                  localStorage.setItem('loginData',JSON.stringify(data))
                })
                this.getDatainfo()
              } else { this._status(res.data) }
            })
          }
        }
      } else if (this.userInfo.personal) {//登录账号为个人账号
        rD.id = this.userInfo.id
        const mapList = [//以下属性是，发生改变的时候才传
          //基本信息
          'areaId',
          'u_nickName', 
          'u_description',
          'u_logo',
          'u_backgroundImg',
          'u_fixPhone',
          'u_phone',
          'u_QQ',
          'u_email',
          'u_weixin',
          'u_weibo',
          'u_startGetJob',
          //求职信息
          'u_birthDayString',
          'u_sex',
          'u_height',
          'u_putonghua',
          'u_waiyu',
          'u_workYear',
          'u_expectSalary',
          'u_idCard',
          'u_school',
          'u_liveAddress',
          'u_marriage',
          'u_jobType',
          'u_expectJob',
          'u_career',
          'u_education',
          'u_major',
          'u_educationExperience',
          'u_workExperience',
          // 'u_resumeNameAndIds',
          'u_videoUrl',
          'selfComments',
          'selfInfo',
          //交友信息
          'openFriends',
          'f_age',
          'f_weight',
          'f_description',
          'f_requirement',
          'f_secDoc',
          'f_disposition',
          'f_friends',
          'f_wordAddress',
        ]
        const mapList2 = [//以下属性是，发生改变的时候才传
          'u_resumeNameAndIds',
        ]
        mapList.forEach(x => {//将修改过的属性和值赋给rD
          this.infoForm[x] != this.userInfo[x] ? rD[x] = this.infoForm[x] : ''
        })
        mapList2.forEach(x => {//将修改过的属性和值赋给rD
          console.log(this.infoForm[x])
          rD[x] = this.infoForm[x] && this.infoForm[x] != this.userInfo[x] ? this.infoForm[x] : null
        })
        if (Object.keys(rD).length == 1) {//未改变任何数据
          this.$message.warning('您未改变任何数据!')
        } else {
          console.log(rD)
          if (this.provinceId == '') {
            this.$message.warning('请选择地区!')
          } else {
            this.$api._user_modify(rD).then(res =>{
              console.log(res)
              if (res.data.status === 0) {
                this.$message.success('修改成功!')
                let id = rD.id
                this.$api._user_userInfo(id).then(res1 => {
                  if (res1.data.status == 0) {
                    let data = JSON.parse(res1.data.data)
                    console.log(data)
                    localStorage.setItem('loginData',JSON.stringify(data))
                  } else { this._status(res1.data) }
                })
              } else { this._status(res.data) }
            })
          }
        }
      }
    },

    //提交律师申请表单
    submitLayerApply() {
      let rD = {}
      rD.imgId = this.lawyerapplyform.imgId
      rD.userId = this.userInfo.id
      this.$api.util_create('lvshisq', rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('申请提交成功，请耐心等待审核！')
        } else { this._status(res.data) }
      })
    },
    //提交律师申请表单
    submitCompanyApply() {
      let rD = {}
      rD.o_img = this.companyapplyform.o_img
      rD.o_name = this.companyapplyform.o_name
      rD.userId = this.userInfo.id
      this.$api.util_create('qiyesq', rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('申请提交成功，请耐心等待审核！')
        } else { this._status(res.data) }
      })
    },
    //提交VIP申请表单
    submitVipApply() {
      let rD = {}
      rD.areaId = this.userInfo.areaId
      rD.applyDescription = this.vipapplyform.applyDescription
      rD.userId = this.userInfo.id
      this.$api.util_create('vipsq', rD).then(res => {
        if (res.data.status == 0) {
          this.$message.success('申请提交成功，请耐心等待审核！')
        } else { this._status(res.data) }
      })
    },

    getUserInfo() {
      return this.$api.get_user_login_info().then(res => {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(_R)
          this.infoForm = _R
          localStorage.setItem('loginData', res.data.data)
        } else { this._status(res.data) }
      })
    }
  },
  async created() {
    // await this.getUserInfo()
    this.infoForm = JSON.parse(JSON.stringify(this.userInfo))
    this.showImg()
    this.setAreaId()
  },
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.getUserInfo()
      vm.infoForm = JSON.parse(JSON.stringify(vm.userInfo))
    })
  },
}
</script>

<style lang='scss' scoped>
.w1000{width: 1000px;border:1px solid #000;margin: 0 auto 20px;padding-bottom: 50px;}
.w1000 h2{text-align: center;line-height: 50px;margin-bottom: 20px;}
.idCardBox{width: 55%;justify-content: space-between;align-items: flex-start;margin-top: 20px;}
/deep/.avatar-uploader .el-upload {border: 1px dashed #d9d9d9;border-radius: 6px;cursor: pointer;position: relative;overflow: hidden;}
.avatar-uploader .el-upload:hover {border-color: #409EFF;}
.avatar-uploader-icon {font-size: 28px;color: #8c939d;width: 178px;height: 178px;line-height: 178px;text-align: center;}
.avatar {width: 178px;height: 178px;display: block;}
.organizationUserInfo .avatar-uploader-icon{width: 500px;height: 250px;line-height: 250px;}
.personalUserInfo .avatar-uploader-icon{width: 300px;}
.organizationUserInfo .videoBox{width: 500px;}
.personalUserInfo .videoBox{width: 300px;}
.personalUserInfo .border-b{border-bottom: 1px solid #eee;padding-bottom: 20px;}
/deep/ .hide .el-upload--picture-card {display: none;}
/deep/ .el-upload-list__item {transition: none !important;}

.personalUserInfo .el-input{width: 300px;}
.personalUserInfo .el-select{width: 300px;}

.organizationUserInfo .el-input{width: 700px;}
.organizationUserInfo .el-select{width: 300px;}

/deep/ textarea{font-family: Arial;}
</style>